import React, { Component } from 'react';
import PropTypes from 'prop-types';




import Result from './Result';
import CalculatorBaseForm from './CalculatorBaseForm';
import CalculatorConfigForm from './CalculatorConfigForm';
import ConversionTable from './conversion-table/ConversionTable';
import formatDate from '../../helper/formatDate';
import SharingBar from './SharingBar';
import currencies from '../../currencies';

class Calculator extends Component {
  constructor(props) {
    super(props);

    let curFrom = this.getCurrency(this.props.match.params.curFrom);
    let curTo = this.getCurrency(this.props.match.params.curTo);

    if (!curFrom || !curTo) {
      curFrom = this.getCurrency('EUR');
      curTo = this.getCurrency('USD');
      this.props.history.replace('/EUR/USD');
    }

    this.state.curFrom = curFrom;
    this.state.curTo = curTo;

    this.props.history.listen(() => {
      this.updateFromRoute();
    });

  }

  state = {
    amount: 1,
    rate: 0,
    rateInverted: 0,
    result: 0,
    curFrom: null,
    curTo: null,
    fee: 0,
    decimals: 4,
    rateDate: new Date(),
    copied: false,
  }


  async componentDidMount() {
    try {
      const rate = await this.getRate(
        this.state.curFrom.value,
        this.state.curTo.value,
        this.state.rateDate,
      );

      const rateInverted = await this.getRate(
        this.state.curTo.value,
        this.state.curFrom.value,
        this.state.rateDate,
      );

      const result = this.getResult(this.state.amount, rate, this.state.fee);

      this.setState({
        rate,
        result,
        rateInverted,
        copied: false,
      });
    } catch (e) {
      console.log(e);
    }
  }

  onCopy = () => {
    this.setState({
      copied: true,
    });
  };

  getCurrency = id => currencies.filter(currency => currency.id === id)[0];

  getResult = (amount, rate, fee) => {
    let newAmount = amount;

    if (newAmount.toString().charAt(newAmount.length - 1) === '.') {
      newAmount = parseFloat(newAmount.substr(0, newAmount.length - 1));
    }

    const result = newAmount * rate;

    return result + (result * fee);
  };

  getRate = async (curFrom, curTo) => {
    const date = formatDate(this.state.rateDate);
    const result = await fetch(`https://currency.calamedia.de/rate/${date}/${curFrom}/${curTo}/`, {
      headers: {
        'X-Api-Key': 'oiasndf389h892fh98vhf02f89j23f98jhcasd28',
      },
    });
    const rate = await result.json();

    return rate.rate;
  };

  updateFromRoute = () => {
    const curFrom = this.getCurrency(this.props.match.params.curFrom);
    const curTo = this.getCurrency(this.props.match.params.curTo);

    this.setState({
      curFrom,
      curTo,
    });
  }

  updateAmount = (event) => {
    let amount = event.target.value.trim().replace(',', '.');

    if (amount.charAt(amount.length - 1) === '.') {
      amount = `${parseFloat(amount.substr(0, amount.length - 1))}.`;
    } else {
      amount = parseFloat(amount);
    }

    if (!amount) {
      amount = 0;
    }

    this.setState({
      amount,
      result: this.getResult(amount, this.state.rate, this.state.fee),
      copied: false,
    });
  };

  updateFee = (event) => {
    const fee = Number(event.target.value);
    const result = this.getResult(this.state.amount, this.state.rate, fee);

    this.setState({
      fee,
      result,
      copied: false,
    });
  };

  updateDecimals = (event) => {
    const decimals = Number(event.target.value);

    this.setState({
      decimals,
    });
  };

  updateRateDate = async (date) => {
    const rateDate = new Date(date);
    const rate = await this.getRate(this.state.curFrom.value, this.state.curTo.value, rateDate);
    const result = this.getResult(this.state.amount, rate, this.state.fee);

    this.setState({
      rateDate,
      rate,
      result,
      copied: false,
    });
  };

  updateCurrencyFrom = async (selectedOption) => {
    if (!selectedOption || selectedOption.value === '') {
      return;
    }

    const curFrom = selectedOption;
    const rate = await this.getRate(curFrom.value, this.state.curTo.value, this.state.rateDate);
    const rateInverted = await this.getRate(this.state.curTo.value, curFrom.value, this.state.rateDate);
    const result = this.getResult(this.state.amount, rate, this.state.fee);

    this.props.history.push(`/${curFrom.id}/${this.state.curTo.id}`);
    this.setState({
      curFrom,
      rate,
      result,
      copied: false,
      rateInverted,
    });
  };

  updateCurrencyTo = async (selectedOption) => {
    if (selectedOption.value === '') {
      return;
    }

    const curTo = selectedOption;
    const rate = await this.getRate(this.state.curFrom.value, curTo.value, this.state.rateDate);
    const rateInverted = await this.getRate(curTo.value, this.state.curFrom.value, this.state.rateDate);
    const result = this.getResult(this.state.amount, rate, this.state.fee);

    this.props.history.push(`/${this.state.curFrom.id}/${curTo.id}`);
    this.setState({
      curTo,
      rate,
      result,
      copied: false,
      rateInverted,
    });
  };

  changeDirection = async () => {
    const curFrom = this.state.curTo;
    const curTo = this.state.curFrom;

    const rate = this.state.rateInverted;
    const rateInverted = this.state.rate;
    const result = this.getResult(this.state.amount, rate, this.state.fee);

    this.props.history.push(`/${curFrom.id}/${curTo.id}`);
    this.setState({
      curFrom,
      curTo,
      rate,
      rateInverted,
      result,
      copied: false,
    });
  };


  render() {
    return (
      <div className="Calculator">
        <div className="Content-wrapper Content-wrapper--calculator">
          <div className="content">
            <CalculatorBaseForm
              curFrom={this.state.curFrom}
              changeDirection={this.changeDirection}
              updateCurrencyTo={this.updateCurrencyTo}
              updateCurrencyFrom={this.updateCurrencyFrom}
              curTo={this.state.curTo}
              amount={this.state.amount}
              updateAmount={this.updateAmount}
            />

            <Result
              result={this.state.result}
              curTo={this.state.curTo.value}
              decimals={this.state.decimals}
              onCopy={this.onCopy}
              copied={this.state.copied}
            />

            <CalculatorConfigForm
              fee={this.state.fee}
              updateFee={this.updateFee}
              decimals={this.state.decimals}
              updateDecimals={this.updateDecimals}
              rateDate={this.state.rateDate}
              updateRateDate={this.updateRateDate}
              rate={this.state.rate}
            />
          </div>
        </div>

        <div className="Content-wrapper Content-wrapper--conversiontable">
          <div className="content">
            <ConversionTable
              ref={el => (this.componentRef = el)}
              fee={this.state.fee}
              rateDate={this.state.rateDate}
              rate={this.state.rate}
              curFrom={this.state.curFrom}
              curTo={this.state.curTo}
              rateInverted={this.state.rateInverted}
            />
          </div>
        </div>
        <div className="Content-wrapper Content-wrapper--sharingbar">
          <div className="content">
            <SharingBar printComponenetRef={this.componentRef} />
          </div>
        </div>
      </div>
    );
  }
}

Calculator.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      curFrom: PropTypes.string,
      curTo: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default Calculator;




// WEBPACK FOOTER //
// ./src/components/calculator/Calculator.js